var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownOption(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61864 7.65596L16.8729 0.401465C17.1469 0.127632 17.4736 -0.00611866 17.8531 0.000214692C18.2326 0.00654804 18.5594 0.146631 18.8334 0.420465C19.1072 0.694465 19.2441 1.02222 19.2441 1.40372C19.2441 1.78522 19.1072 2.11296 18.8334 2.38696L11.2349 9.97221C11.0071 10.2 10.7522 10.37 10.4704 10.482C10.1884 10.594 9.90447 10.65 9.61864 10.65C9.33281 10.65 9.04889 10.594 8.76689 10.482C8.48505 10.37 8.23022 10.2 8.00239 9.97221L0.397888 2.36796C0.124054 2.09396 -0.00869568 1.77038 -0.000362457 1.39721C0.00797077 1.02405 0.149054 0.700464 0.422888 0.426464C0.696888 0.152631 1.02464 0.0157138 1.40614 0.0157139C1.78764 0.0157139 2.11539 0.152631 2.38939 0.426465L9.61864 7.65596Z",
    fill: "#1C1B1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownOption);
export default __webpack_public_path__ + "static/media/arrow_down_option.313e17e93a0e2dc2cd360f77f0e101bc.svg";
export { ForwardRef as ReactComponent };